export enum Breakpoint {
    XSmall,
    Small,
    Medium,
    Large, 
    XLarge
}
